import { render } from "./GaleriaBtn.vue?vue&type=template&id=5bea2d44&scoped=true"
import script from "./GaleriaBtn.vue?vue&type=script&lang=js"
export * from "./GaleriaBtn.vue?vue&type=script&lang=js"

import "./GaleriaBtn.vue?vue&type=style&index=0&id=5bea2d44&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bea2d44"]])

export default __exports__